import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
import moment from "moment/moment"
const livesessions = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 100,
            total: 0,
            page: 1,
        },
        itemsParticipant: [],
        listScenes: [],
        selectedItems: [],
        loading: true,
        participants: [],
        vimeoItems: [],
        archives: [],
        archiveFilter : {
            skip: 0,
            take: 20,
            page:1,
            total:0,
            searchTerm: null,
            ids: [],
            sessionId: null,
        },
    }),
    mutations: {
        setLiveStreamArchiveList(state,payload){
            state.archives = payload.items
            state.archiveFilter.total = payload.totalCount
        },
        setLiveSessions(state, payload) {
            state.items = [];
            payload.items.map((x) => {
                state.items.push({...x, show: false });
            });
            state.participants = payload.participants;
            state.vimeoItems = payload.vimeoItems;
            state.filter.total = payload.totalCount;
        },
        setSelectedLiveSessions(state, payload) {
            state.selectedItems = payload;
        },
        setLiveSessionPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getLiveSessions');
        },
        setLiveSessionTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getLiveSessions');
        },
    },
    actions: {
        async deleteLiveStreamArchive(store,payload){
            var res = await axios.post('livestream/deletearchive', {id : payload});
            if(res.data.alert.hasError){
                Message.error(res.data.alert.message)
            }else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getLiveStreamArchiveList(store,payload){
            var res = await axios.post('livestream/listarchives', {...payload, skip: (payload.page - 1) * payload.take });
            if(res.data.alert.hasError){
                Message.error(res.data.alert.message)
            }
            store.commit('setLiveStreamArchiveList', res.data.data);
            return res;
        },
        async liveStreamDeleteScene(store, payload) {
            var res = await axios.post('livestream/deletescene', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                store.state.listScenes = store.state.listScenes.filter((x) => x.id != payload);
            }
            return res;
        },
        async listScenes(store, payload) {
            var res = await axios.post('livestream/listscenes', { skip: 0, take: 1000 });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            store.state.listScenes = res.data.data.items;
            return res;
        },
        async liveStreamAddUpdateScene(store, payload) {
            var res = await axios.post('/livestream/addorupdatescene', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async updateLiveStream(store, payload) {
     
            var res = await axios.post('livestream/update', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getLiveStream(store, payload) {
            var res = await axios.post('livestream/get', { id: payload });
            return res;
        },
        async createLiveStream(store, payload) {
            var res = await axios.post('livestream/create', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                await store.dispatch('getLiveSessions');
            }
            return res;
        },
        async getLiveSessions(store) {
            store.state.loading = true;
            var res = await axios.post('livestream/list', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });
            store.commit('setLiveSessions', res.data.data);
            store.state.loading = false;
            return res;
        },
        async toggleLiveSession(store, payload) {
            var res = await axios.post('livestream/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteLiveSession(store, payload) {
            var res = await axios.post('livestream/delete', {
                id: payload,
            });

            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message)
            } else {
                Message.success(res.data.alert.message)
                await store.dispatch('getLiveSessions');
            }
        },
        async saveLiveSessionOrders(context, payload) {
            var res = await axios.post('/livestream/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
    },
    getters: {
        getLiveStreamArchiveList: (state) => state.archives,
        getLiveStreamArchiveFilter: (state) => state.archiveFilter,
    },
};
export default livesessions;


// WEBPACK FOOTER //
// ./src/store/livesessions.js